import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SvgLoading } from 'components/Svgs';
import Spinner from 'components/Spinner';

import './Button.scss';

const Button = React.forwardRef((props, ref) => {
  const {
    tagName: Tag,
    type = Tag === 'button' ? 'button' : null,
    className,
    children,
    styled,
    disabled,
    waiting,
    waitSpinner,
    ...rest
  } = props;

  const classes = classNames('button', className, {
    bt: styled,
    'bt--primary': styled && !['secondary', 'tertiary', 'danger', 'link'].includes(styled),
    'bt--secondary': styled === 'secondary',
    'bt--tertiary': styled === 'tertiary',
    'bt--outline': styled && ['primary-outline', 'danger'].includes(styled),
    'bt--danger': styled && ['danger', 'danger-solid'].includes(styled),
    'bt--inline-link': styled === 'inline-link',
    'bt--link': styled === 'link',
  });

  // The default waiting animation is loading dots. If `waitSpinner` is true, a spinner will display instead.
  const waitingAnimation = waitSpinner ? <Spinner /> : <SvgLoading className="button__waiting" />;

  return (
    <Tag ref={ref} {...rest} type={type} className={classes} disabled={disabled || waiting}>
      {waiting ? waitingAnimation : children}
    </Tag>
  );
});

Button.TYPES = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit',
};

Button.defaultProps = {
  tagName: 'button',
  styled: true,
  waitSpinner: false,
  // `type` handled by default-args to have access to `tagName`
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  styled: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'primary-outline',
    'danger',
    'danger-solid',
    'inline-link',
    'link',
    true,
    false,
  ]),
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  type: PropTypes.string,
  waiting: PropTypes.bool,
  waitSpinner: PropTypes.bool,
};

export default Button;
